<div [attr.aria-label]="ariaLabel" tabindex="0" role="status">
    <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
